module.exports = __webpack_public_path__ + "img/moving.333e0d53.svg";